var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopWatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/stop-watch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Impact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact-Section",
    transform: "translate(-757.000000, -180.000000)",
    fill: "#8C8C8C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(267.500000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statistic-Card",
    transform: "translate(464.500000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statistic",
    transform: "translate(24.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/stop-watch",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5776956,4.12848696 L11.3574099,3.35377089 C11.4841927,3.22698807 11.533707,3.04219808 11.4873013,2.86900953 C11.4408956,2.69582097 11.3056199,2.56054532 11.1324314,2.51413958 C10.9592428,2.46773385 10.7744528,2.51724818 10.64767,2.644031 L9.87295393,3.42374524 C8.92433726,2.61591141 7.74597724,2.12638499 6.50418854,2.02425814 L6.50418854,0.999633648 L7.50382218,0.999633648 C7.77986339,0.999633648 8.00363901,0.775858033 8.00363901,0.499816824 C8.00363901,0.223775614 7.77986339,0 7.50382218,0 L4.50492124,0 C4.22888003,0 4.00510442,0.223775614 4.00510442,0.499816824 C4.00510442,0.775858033 4.22888003,0.999633648 4.50492124,0.999633648 L5.50455489,0.999633648 L5.50455489,2.02425814 C2.74566435,2.25210061 0.50110616,4.33852133 0.0726673569,7.07344901 C-0.355771446,9.80837668 1.14322305,12.4812419 3.70027192,13.5418503 C6.25732079,14.6024588 9.20806981,13.7752507 10.8411591,11.539986 C12.4742484,9.30472121 12.3653803,6.24215029 10.5776956,4.12848696 L10.5776956,4.12848696 Z M6.00437171,12.9952374 C3.24395962,12.9952374 1.00620347,10.7574813 1.00620347,7.99706918 C1.00620347,5.23665709 3.24395962,2.99890094 6.00437171,2.99890094 C8.76478381,2.99890094 11.0025399,5.23665709 11.0025399,7.99706918 C11.0025399,9.32266582 10.4759487,10.5939695 9.53861037,11.5313078 C8.601272,12.4686462 7.32996835,12.9952374 6.00437171,12.9952374 L6.00437171,12.9952374 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50418854,7.79214428 L6.50418854,4.99816824 C6.50418854,4.72212703 6.28041292,4.49835141 6.00437171,4.49835141 C5.7283305,4.49835141 5.50454652,4.72212703 5.50454652,4.99816824 L5.50454652,7.99706918 C5.50378679,8.12992198 5.5559428,8.25761428 5.64950177,8.35193912 L7.14895224,9.8513896 C7.24280114,9.94601124 7.37055226,9.99923458 7.50382218,9.99923458 C7.63709211,9.99923458 7.76484322,9.94601124 7.85869213,9.8513896 C7.95331378,9.75754069 8.00653711,9.62978958 8.00653711,9.49651965 C8.00653711,9.36324972 7.95331378,9.23549861 7.85869213,9.14164971 L6.50418854,7.79214428 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopWatch);
export default __webpack_public_path__ + "static/media/stop-watch.292905e09833e371869bff3c73b358ed.svg";
export { ForwardRef as ReactComponent };